import { getBackTest, runBackTest } from 'state/backTest/backTest.actions';
import { getBackTestByTabId } from 'state/backTest/backTest.selector';
import type { Thunk } from 'state/state.common';

export const retryBackTest =
  (tabId: string): Thunk<void> =>
  (dispatch, getState) => {
    const backTest = getBackTestByTabId(getState(), tabId);
    if (!backTest) {
      return;
    }
    if (backTest.backTestId) {
      dispatch(getBackTest(tabId, backTest.backTestId));
    } else {
      dispatch(runBackTest(tabId));
    }
  };
